import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';
import './Ventas.css';

const Ventas = () => {
  const { user } = useAuth();
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!user) return;
    cargarVentas();
  }, [user]);

  const cargarVentas = async () => {
    try {
      setLoading(true);
      setError('');
      let endpoint = '/ventas/mis-compras';
      if (user.tipoUsuario === 'ADMIN') endpoint = '/ventas/todas';
      else if (user.tipoUsuario === 'FOTOGRAFO') endpoint = '/ventas/mis-ventas';

      const response = await api.get(endpoint);
      setVentas(response.data);
    } catch (err) {
      setError('No se pudieron cargar los registros de ventas.');
    } finally {
      setLoading(false);
    }
  };

  const estadoClase = (estado) => {
    switch (estado) {
      case 'COMPLETADA': return 'estado-completada';
      case 'PENDIENTE':  return 'estado-pendiente';
      case 'CANCELADA':  return 'estado-cancelada';
      case 'REEMBOLSADA': return 'estado-reembolsada';
      default: return '';
    }
  };

  const formatFecha = (fecha) => {
    if (!fecha) return '-';
    return new Date(fecha).toLocaleString('es-MX', {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  const titulo = () => {
    if (user?.tipoUsuario === 'ADMIN') return 'Todas las ventas';
    if (user?.tipoUsuario === 'FOTOGRAFO') return 'Mis ventas de fotos';
    return 'Mis compras';
  };

  return (
    <div className="ventas-container">
      <h1 className="ventas-titulo">{titulo()}</h1>

      {loading && <LoadingSpinner mensaje="Cargando registros..." />}
      {error && <p className="ventas-error">{error}</p>}

      {!loading && !error && ventas.length === 0 && (
        <p className="ventas-empty">No hay registros de ventas aún.</p>
      )}

      {!loading && ventas.length > 0 && (
        <div className="ventas-table-wrapper">
          <table className="ventas-table">
            <thead>
              <tr>
                <th>#</th>
                {(user?.tipoUsuario === 'ADMIN' || user?.tipoUsuario === 'FOTOGRAFO') && <th>Comprador</th>}
                {user?.tipoUsuario === 'ADMIN' && <th>Fotógrafo</th>}
                <th>Foto ID</th>
                <th>Corredor</th>
                <th>Monto</th>
                {user?.tipoUsuario === 'FOTOGRAFO' && <th>Tu parte (80%)</th>}
                <th>Estado</th>
                <th>Método de Pago</th>
                <th>Fecha</th>
              </tr>
            </thead>
            <tbody>
              {ventas.map((v) => (
                <tr key={v.id}>
                  <td>{v.id}</td>

                  {(user?.tipoUsuario === 'ADMIN' || user?.tipoUsuario === 'FOTOGRAFO') && (
                    <td>
                      {v.comprador ? (
                        <span title={v.comprador.email}>
                          {v.comprador.nombreCompleto}
                          {v.comprador.whatsappNumero && (
                            <span className="whatsapp-badge"> 📱{v.comprador.whatsappNumero}</span>
                          )}
                        </span>
                      ) : '-'}
                    </td>
                  )}

                  {user?.tipoUsuario === 'ADMIN' && (
                    <td>{v.fotografo?.nombreCompleto || '-'}</td>
                  )}

                  <td>{v.foto?.id || '-'}</td>

                  <td>{v.foto?.numeroCorredorDetectado || '-'}</td>

                  <td className="monto">
                    ${v.montoTotal?.toFixed(2)}
                  </td>

                  {user?.tipoUsuario === 'FOTOGRAFO' && (
                    <td className="monto monto-fotografo">
                      ${(v.montoTotal * 0.8)?.toFixed(2)}
                    </td>
                  )}

                  <td>
                    <span className={`estado-badge ${estadoClase(v.estado)}`}>
                      {v.estado}
                    </span>
                  </td>

                  <td>{v.metodoPago?.replace('_', ' ') || '-'}</td>

                  <td>{formatFecha(v.fechaVenta)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loading && ventas.length > 0 && user?.tipoUsuario !== 'ATLETA' && (
        <div className="ventas-resumen">
          <p>
            <strong>Total de registros:</strong> {ventas.length}
          </p>
          <p>
            <strong>Ingresos totales:</strong> ${
              ventas
                .filter(v => v.estado === 'COMPLETADA')
                .reduce((sum, v) => sum + (v.montoTotal || 0), 0)
                .toFixed(2)}
          </p>
          {user?.tipoUsuario === 'FOTOGRAFO' && (() => {
            const total = ventas
              .filter(v => v.estado === 'COMPLETADA')
              .reduce((sum, v) => sum + (v.montoTotal || 0), 0);
            return (
              <>
                <p className="resumen-fotografo">
                  <strong>Tu parte (80%):</strong> <span className="monto-verde">${(total * 0.8).toFixed(2)}</span>
                </p>
                <p className="resumen-plataforma">
                  <strong>Comisión plataforma (20%):</strong> <span className="monto-gris">${(total * 0.2).toFixed(2)}</span>
                </p>
              </>
            );
          })()}
        </div>
      )}
    </div>
  );
};

export default Ventas;
